var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef, useEffect } from 'react';
import warning from 'warning';
import { Loader } from 'modules/Loader';
import { Falcon } from 'modules/macro';
import { ResetButton } from './components/ResetButton';
import { Input, InputContainer, Adornment } from './styled';
export const SearchInput = forwardRef((props, forwardedRef) => {
    const { value, onReset, disabled, onChange, resetLabel, stretch = false, invalid = false, loading = false, className, size = 'md' } = props, rest = __rest(props, ["value", "onReset", "disabled", "onChange", "resetLabel", "stretch", "invalid", "loading", "className", "size"]);
    if (__DEV__) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
            warning(!(onChange && value && !onReset), '"onReset" function is required when using controlled searched');
            warning(!(onReset && !resetLabel), '"resetLabel" is required for accessibility when providing "onReset" function');
        }, [resetLabel, onChange, value, onReset]);
    }
    const showReset = Boolean(value && onReset && !disabled);
    const inputProps = Object.assign(Object.assign({}, rest), { value,
        onChange,
        disabled, ref: forwardedRef });
    return (<InputContainer $invalid={invalid} $stretch={stretch} $size={size} className={className}>
      <Adornment>
        <Falcon icon="magnifying-glass" $color="semantic.text.100"/>
      </Adornment>
      <Input type="search" {...inputProps}/>
      <Adornment>
        {loading ? <Loader size={8}/> : <ResetButton show={showReset} onClick={onReset} label={resetLabel}/>}
      </Adornment>
    </InputContainer>);
});
SearchInput.displayName = 'SearchInput';
